const EMPLOYMENT_STATUSES = [
  'active',
  'on_leave',
  'terminated'
];

export default EMPLOYMENT_STATUSES;
